<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        设备状态 实时状态管理
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column prop="c_name" align="center" label="单位名称"> </el-table-column>
          <el-table-column prop="ct_transmission_name" label="设备名称" align="center"> </el-table-column>

          <el-table-column prop="ct_transmission_num" align="center" label="设备型号"> </el-table-column>
          <el-table-column prop="mc_name" label="设备类型" align="center"> </el-table-column>

          <el-table-column prop="ct_open_date" align="center" label="使用时间"> </el-table-column>

          <el-table-column prop="mname" align="center" label="设备状态">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain v-if="scope.row.status">在线</el-button>
              <el-button type="info" size="mini" plain v-else>离线</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="showDia = false" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-backtop target=".common-body-style" :title="'返回顶部'"></el-backtop>
  </div>
</template>

<script>
// import {getDevStatus} from '../../api/device'
export default {
  data() {
    return {
      list: [],
      params: { page: 1 },
      total: 0,
      showDia: false,
      searchForm: this.$getForm('unitSearch'),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      // getDevStatus(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post('/monitor/devicestatesone').then((res) => {
        this.list = res.data.device;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
